import * as actions from './TournamentListActions'

export default (state = actions.getInitialState(), action = {}) => {
  switch (action.type) {
    case actions.TOURNAMENT_LIST_FETCH: {
      return { ...state, ...action.payload, loaded: false, loading: true }
    }
    case actions.TOURNAMENT_LIST_FETCH_CANCELED: {
      return { ...state, loading: false }
    }
    case actions.TOURNAMENT_LIST_FETCH_ERROR: {
      return { ...state, error: action.payload.error, loaded: true, loading: false }
    }
    case actions.TOURNAMENT_LIST_FETCH_FULFILLED: {
      return { ...state, ...action.payload, loaded: true, loading: false }
    }
    default:
  }
  return state
}
